import { ImpactProfileTitle, titleByLanguage } from '@upright/common/model/input/impacts';
import { ImpactLanguage } from '@upright/common/model/input/types';
import {
  useImpactChartContext,
  useImpactChartFontSizes,
  useImpactChartHeights,
  useImpactChartWidths,
} from '../context';
import { Text } from './shared';

export function ColumnTitlesRowDesktop() {
  const { staticMode, language, simplify } = useImpactChartContext();
  const widths = useImpactChartWidths();
  const heights = useImpactChartHeights();
  const { columnTitles } = useImpactChartFontSizes();
  const style = {
    fontSize: columnTitles,
  };
  return (
    <svg height={heights.columnTitlesRow} width={widths.full} style={{ display: 'block' }}>
      <g transform={`translate(0, ${heights.columnTitlesRow / 2})`}>
        <Text x={staticMode ? widths.titleTextLeftLine : widths.titleIconLeftLine} dy="0.35em" style={style}>
          {getFriendlyTitle(ImpactProfileTitle.IMPACT, language)}
        </Text>
        <Text x={widths.title + widths.bars} textAnchor="end" dy="0.35em" style={style}>
          {getFriendlyTitle(ImpactProfileTitle.NEGATIVE, language)}
        </Text>
        {simplify ? undefined : (
          <Text x={widths.title + widths.bars + widths.middle / 2} dy="0.35em" textAnchor="middle" style={style}>
            {getFriendlyTitle(ImpactProfileTitle.SCORE, language)}
          </Text>
        )}
        <Text x={widths.title + widths.bars + widths.middle} textAnchor="start" dy="0.35em" style={style}>
          {getFriendlyTitle(ImpactProfileTitle.POSITIVE, language)}
        </Text>
      </g>
    </svg>
  );
}

function getFriendlyTitle(title: ImpactProfileTitle, lang: ImpactLanguage = ImpactLanguage.en): string {
  return titleByLanguage[lang][title];
}
